import { isWorkbench } from '../../utils/piction';

function countItems(array) {
  const counts = {};
  array.forEach((item) => {
    counts[item] = (counts[item] || 0) + 1;
  });
  return counts;
}

export const isValidForBulkEdit = (searchParams) => {
  if (!isWorkbench()) return false;
  const IN_CATEGORY = 'IN_CATEGORY';
  let tagList = searchParams.tagList || [];
  let categoriesOnSearch = [];
  for (const tag of tagList) {
    if (tag.searchTerm && tag.searchTerm.keyword == IN_CATEGORY) {
      categoriesOnSearch.push(tag.searchTerm.value);
    }
  }
  let categoriesCount = countItems(categoriesOnSearch);
  let noOfCategories = Object.keys(categoriesCount).length;
  return noOfCategories === 1;
};

export const getFileSize = (umo) => {
  let size = '';
  let origData =
    umo.data.o && umo.data.o.find((item) => item.$ && item.$.o === '1');
  origData = origData ? origData.$ : false;
  switch (umo.type) {
    case 'PHOTO':
      if (origData) {
        size = origData.sz ? origData.sz : '';
      }
      break;
    case 'VIDEO':
      size = umo.metadataList.getMetadata('VIDEO.FILESIZE')
        ? umo.metadataList.getMetadata('VIDEO.FILESIZE').value
        : '';
      break;
    case 'AUDIO':
      size = umo.metadataList.getMetadata('AUDIO.FILESIZE')
        ? umo.metadataList.getMetadata('AUDIO.FILESIZE').value
        : '';
      break;
    default:
      size = origData && origData.sz ? origData.sz : '';
      break;
  }
  return size;
};
